import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { regions } from "@/mocks/properties";
import { useTranslation } from "react-i18next";

export default function Regions() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main className="pt-24 md:pt-32 pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12 mb-16 md:mb-24">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("regions.sectionLabel")}</p>
            <h1 className="font-serif text-4xl md:text-5xl font-semibold text-ink mb-6 leading-tight">{t("regions.title")}</h1>
            <p className="text-lg text-ink/50 font-light max-w-2xl leading-relaxed">{t("regions.intro")}</p>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {regions.map((region) => (
              <div key={region.name}
                className="group bg-white border border-hairline p-6 md:p-8 hover:border-ink/20 transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="font-serif text-xl font-semibold text-ink">{region.name}</h3>
                  <span className="text-xs font-medium text-gold bg-gold/10 px-2 py-1">{region.priceRange}</span>
                </div>
                <p className="text-sm text-ink/50 leading-relaxed font-light mb-4">{region.tagline}</p>
                <div className="flex items-center gap-1.5 text-xs text-ink/30">
                  <i className="ri-map-pin-line"></i>
                  <span>{t("regions.activeArea")}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="bg-ink p-8 md:p-12 text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("regions.mapLabel")}</p>
            <p className="text-paper/50 font-light max-w-xl mx-auto mb-6">{t("regions.mapDesc")}</p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-4xl mx-auto">
              {["Shizuoka", "Yamanashi", "Highland", "Odawara", "Kawasaki", "Yokohama", "Hakone", "Chiba", "Saitama", "Tokyo Tama", "Ibaraki"].map((loc) => (
                <div key={loc} className="bg-paper/10 px-3 py-2 text-xs text-paper/60 border border-paper/10">{loc}</div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-6">{t("regions.inventoryLabel")}</p>
            <div className="space-y-4">
              {[
                { region: "Kanto / Tokai", count: 4, types: "Kominka, Detached Houses" },
                { region: "Kanagawa", count: 3, types: "Kominka, Detached Houses, Condos" },
                { region: "Chiba", count: 2, types: "Detached Houses" },
                { region: "Saitama", count: 2, types: "Detached Houses" },
                { region: "Tokyo", count: 1, types: "Detached House" },
                { region: "Ibaraki", count: 1, types: "Apartment Block" },
              ].map((r) => (
                <div key={r.region} className="flex items-center justify-between py-4 border-b border-hairline">
                  <div>
                    <p className="font-medium text-ink text-sm">{r.region}</p>
                    <p className="text-xs text-ink/40 font-light">{r.types}</p>
                  </div>
                  <div className="text-right">
                    <span className="font-serif text-lg font-semibold text-ink">{r.count}</span>
                    <span className="text-xs text-ink/40 ml-1">{t("regions.properties")}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}